import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=35da4dca&scoped=true"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"
import style0 from "./Verify.vue?vue&type=style&index=0&id=35da4dca&prod&lang=scss"
import style1 from "./Verify.vue?vue&type=style&index=1&id=35da4dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_cache-loader@4.1.0_webpack@4.47.0__css-load_1b3fe109433f9fe6108f2b5a977879df/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35da4dca",
  null
  
)

export default component.exports